import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";
import { TransparentLogoImage } from "./TransparentLogoImage";
import logoHe from "@/assets/logo-he.svg";
import logoEn from "@/assets/logo-en.png";

interface LogoProps {
  variant?: "default" | "light" | "dark";
  size?: "sm" | "md" | "lg";
  showTagline?: boolean;
  className?: string;
}

export function Logo({ 
  variant = "default", 
  size = "md", 
  showTagline = false,
  className 
}: LogoProps) {
  const { language } = useLanguage();
  
  const sizes = {
    sm: { logo: "h-14", tagline: "text-xs" },
    md: { logo: "h-20", tagline: "text-sm" },
    lg: { logo: "h-28", tagline: "text-base" },
  };

  const taglineColors = {
    default: "text-muted-foreground",
    light: "text-primary-foreground/90",
    dark: "text-muted-foreground",
  };

  const logoAlt = language === 'he' ? "לוגו אדם בטיחות - ייעוץ וניהול בטיחות בעבודה" : "Adam Safety Logo - Occupational Safety Consulting and Management";
  const tagline = language === 'he' ? "הבטיחות שלך, המומחיות שלנו" : "Your Safety, Our Expertise";

  return (
    <div className={cn("flex flex-col items-center justify-center text-center group", className)}>
      {language === 'he' ? (
        <img
          src={logoHe}
          alt={logoAlt}
          loading="eager"
          decoding="async"
          className={cn(
            sizes[size].logo,
            "w-auto object-contain transition-transform duration-300 group-hover:scale-105"
          )}
        />
      ) : (
        <TransparentLogoImage
          src={logoEn}
          alt={logoAlt}
          className={cn(
            sizes[size].logo,
            "w-auto object-contain transition-transform duration-300 group-hover:scale-105"
          )}
        />
      )}
      {showTagline && (
        <span className={cn(
          sizes[size].tagline,
          taglineColors[variant],
          "font-semibold tracking-wide transition-colors duration-300 mt-2.5 whitespace-nowrap text-center w-full"
        )}>
          {tagline}
        </span>
      )}
    </div>
  );
}